<template>
    <section class="fullwidth">
        <!-- <div class="bottom-bd"></div> -->
        <Map class="animated-map" />
        <section class="body-content">
            <GridBox>
                <GridItem size="100%" :colidx="3" glassy>
                    <GridBody class="where-body">
                        <h1
                            class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
                        >
                            {{ $t("where.title") }}
                        </h1>

                        <p
                            class="subtitle mt-2 is-subtle has-text-weight-normal"
                        >
                            {{ $t("where.description") }}
                            <b-icon
                                icon-pack="fas"
                                class="is-primary"
                                icon="fas fa-map-marker"
                            />

                            <a
                                class="is-primary"
                                href="https://www.google.com/maps/search/?api=1&query=tempio+del+futuro+perduto"
                                target="_blank"
                            >
                                {{ $t("where.location") }}
                            </a>
                        </p>
                        <h1
                            class="subtitle is-4 is-uppercase has-text-primary-alt has-text-weight-bold"
                        >
                            {{ $t("where.wall.title") }}
                        </h1>

                        <h3
                            class="date-details is-size-6 is-primary is-uppercase has-text-weight-bold"
                        >
                            <span> {{ $t("where.wall.days") }} </span>
                        </h3>
                        <h3
                            class="date-details is-size-6 is-subtle is-uppercase has-text-weight-bold"
                        >
                            <b-icon
                                icon-pack="fas"
                                class="is-primary"
                                icon="fas fa-clock"
                            />
                            <span>
                                {{ $t("where.wall.startHour") }}
                                <b-icon
                                    icon-pack="fas"
                                    class="is-primary"
                                    icon="fas fa-arrow-right"
                                />
                                {{ $t("where.wall.endHour") }}
                            </span>
                        </h3>
                        <h3
                            class="date-details is-size-6 is-subtle is-uppercase has-text-weight-bold"
                        >
                            <span> {{ $t("where.wall.closingDays") }} </span>
                        </h3>
                    </GridBody>
                </GridItem>
            </GridBox>
        </section>
    </section>
</template>

<style lang="scss" scoped>
.where-body {
    padding: 1rem 0.5rem;
}
.animated-map {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.body-content {
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 50vh;
    /* margin-bottom: 2rem; */
    padding: 0 1rem;
}
</style>
<script>
import Map from "~/components/Map";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import GridBody from "~/components/GridBody";
export default {
    name: "Where",
    data() {
        return {
            pageTitle: "TDF*P — " + this.$t("where.meta.title"),
        };
    },
    components: {
        Map,
        GridBox,
        GridItem,
        GridBody,
    },

    head() {
        return {
            title: this.pageTitle,
        };
    },
    layout: "default",
    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("where.header"));
        },
    },

    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("where.header"));
        this.enterAnimation();
    },

    methods: {
        enterAnimation() {
            const anime = this.$anime;

            anime({
                targets: ".animated-map",
                easing: "easeInOutQuad",
                // backgroundColor: '#FFF',
                // translateY: [3, 0],
                opacity: [0, 1],
                // scale: [0.995, 1],
                filter: ["blur(6rem)", "blur(0px)"],
                duration: 1200,
            });
        },
    },
    // beforeMount() {
    // },
    // beforeDestroy() {
    // },
};
</script>
